"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = exports.TitleStyle = exports.Text = exports.TTitle = exports.TSubtitle = exports.THeading = exports.TCaption = exports.TBodyRegular = exports.TBodyGray = exports.TBodyBold = exports.SubtitleStyle = exports.HeadingStyle = exports.CaptionStyle = exports.BodyRegularStyle = exports.BodyGrayStyle = exports.BodyBoldStyle = exports.BloxText = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _PTTLayout = require("./PTTLayout");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/** Base typography styles
 * DEPRECATED - use $light or $bold if necessary
 * $fw : font-weight
 * DEPRECATED - use $fs_sm, $fs_md, $fs_lg or $fs_xl
 * $fs : font-size
 * $lh : line-height
 * DEPRECATED - use $cname instead
 * $c : color
 * $ws: white-space
 * $italic: adds 'font-style: italic' when true, else font-style is not specified
 * $light: light font-weight
 * $bold: bold font-weight
 * $fs_sm: small font size;
 * $fs_md: medium font size;
 * $fs_lg: large font size;
 * $fs_xl: xl font size;
 * $cname: color variable name ("X" in "--blox-X")
 */
var Typography = (0, _styledComponents.css)(["font-family:var(--blox-font-family);", ";", ";", " line-height:", ";", " ", ""], function (props) {
  if (props.$light) {
    return 'font-weight: var(--blox-font-weight-300);';
  } else if (props.$bold) {
    return 'font-weight: var(--blox-font-weight-700);';
  } else if (props.$fw) {
    return "font-weight:".concat(props.$fw, ";");
  }
}, function (props) {
  if (props.$fs_sm) {
    return 'font-size: var(--blox-font-size-sm);';
  } else if (props.$fs_md) {
    return 'font-size: var(--blox-font-size-md);';
  } else if (props.$fs_lg) {
    return 'font-size: var(--blox-font-size-lg);';
  } else if (props.$fs_xl) {
    return 'font-size: var(--blox-font-size-xl);';
  } else if (props.$fs) {
    return "font-size: ".concat((0, _PTTLayout.pxValue)(props.$fs), ";");
  }
}, function (props) {
  return props.$italic && (0, _styledComponents.css)(["font-style:italic;"]);
}, function (props) {
  return props.$lh ? (0, _PTTLayout.pxValue)(props.$lh) : 'var(--blox-line-height)';
}, function (props) {
  if (props.$cname) {
    return "color: var(--blox-".concat(props.$cname, ");");
  } else if (props.$c) {
    return "color: ".concat(props.$c, ";");
  }
}, function (props) {
  if (props.$ws) {
    return "white-space: ".concat(props.$ws, ";");
  }
});
exports.Typography = Typography;

var Text = _styledComponents["default"].div.withConfig({
  displayName: "Typography__Text",
  componentId: "sc-7qywcj-0"
})(["", " ", ""], Typography, _PTTLayout.Layout);
/**
 * Renders a blox typography component. 
 * Add one of the blox typography classes to select the typography style (see Blox storybook for more info).
 * This renders a div by default. Use the "as" property to render a different tag.
 */


exports.Text = Text;

var BloxText = _styledComponents["default"].div.attrs({
  className: 'blox'
}).withConfig({
  displayName: "Typography__BloxText",
  componentId: "sc-7qywcj-1"
})(["&&&{", " ", "}"], Typography, _PTTLayout.Layout);
/* Below components are deprecated */

/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */


exports.BloxText = BloxText;
var TitleStyle = (0, _styledComponents.css)(["font-weight:400;font-size:30px;line-height:30px;color:var(--blox-slate5);"]);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */

exports.TitleStyle = TitleStyle;

var TTitle = _styledComponents["default"].div.withConfig({
  displayName: "Typography__TTitle",
  componentId: "sc-7qywcj-2"
})(["", " ", " ", ""], TitleStyle, Typography, _PTTLayout.Layout);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */


exports.TTitle = TTitle;
var HeadingStyle = (0, _styledComponents.css)(["font-weight:400;font-size:22px;line-height:22px;color:var(--blox-slate5);"]);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */

exports.HeadingStyle = HeadingStyle;

var THeading = _styledComponents["default"].div.withConfig({
  displayName: "Typography__THeading",
  componentId: "sc-7qywcj-3"
})(["", " ", " ", ""], HeadingStyle, Typography, _PTTLayout.Layout);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */


exports.THeading = THeading;
var SubtitleStyle = (0, _styledComponents.css)(["font-weight:400;font-size:16px;line-height:16px;color:var(--blox-slate5);"]);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */

exports.SubtitleStyle = SubtitleStyle;

var TSubtitle = _styledComponents["default"].div.withConfig({
  displayName: "Typography__TSubtitle",
  componentId: "sc-7qywcj-4"
})(["", " ", " ", ""], SubtitleStyle, Typography, _PTTLayout.Layout);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */


exports.TSubtitle = TSubtitle;
var BodyRegularStyle = (0, _styledComponents.css)(["font-weight:400;font-size:14px;line-height:18px;color:var(--blox-slate5);"]);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */

exports.BodyRegularStyle = BodyRegularStyle;

var TBodyRegular = _styledComponents["default"].div.withConfig({
  displayName: "Typography__TBodyRegular",
  componentId: "sc-7qywcj-5"
})(["", " ", " ", ""], BodyRegularStyle, Typography, _PTTLayout.Layout);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */


exports.TBodyRegular = TBodyRegular;
var BodyBoldStyle = (0, _styledComponents.css)(["font-weight:700;font-size:14px;line-height:14px;color:var(--blox-slate5);"]);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */

exports.BodyBoldStyle = BodyBoldStyle;

var TBodyBold = _styledComponents["default"].div.withConfig({
  displayName: "Typography__TBodyBold",
  componentId: "sc-7qywcj-6"
})(["", " ", " ", ""], BodyBoldStyle, Typography, _PTTLayout.Layout);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */


exports.TBodyBold = TBodyBold;
var BodyGrayStyle = (0, _styledComponents.css)(["", " color:var(--blox-slate3);"], BodyRegularStyle);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */

exports.BodyGrayStyle = BodyGrayStyle;

var TBodyGray = _styledComponents["default"].div.withConfig({
  displayName: "Typography__TBodyGray",
  componentId: "sc-7qywcj-7"
})(["", " ", " ", ""], BodyGrayStyle, Typography, _PTTLayout.Layout);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */


exports.TBodyGray = TBodyGray;
var CaptionStyle = (0, _styledComponents.css)(["font-weight:400;font-size:12px;line-height:12px;color:var(--blox-slate5);"]);
/**
 * @deprecated - Typography is now managed in blox. Use BloxText with a typography class instead. See Blox storybook for more info.
 */

exports.CaptionStyle = CaptionStyle;

var TCaption = _styledComponents["default"].div.withConfig({
  displayName: "Typography__TCaption",
  componentId: "sc-7qywcj-8"
})(["", " ", " ", ""], CaptionStyle, Typography, _PTTLayout.Layout);

exports.TCaption = TCaption;